"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotyButton = void 0;
var Utils = babelHelpers.interopRequireWildcard(require("utils"));

var NotyButton = function NotyButton(html, classes, cb) {
  var _this = this;

  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  babelHelpers.classCallCheck(this, NotyButton);
  this.dom = document.createElement('button');
  this.dom.innerHTML = html;
  this.id = attributes.id = attributes.id || Utils.generateID('button');
  this.cb = cb;
  Object.keys(attributes).forEach(function (propertyName) {
    _this.dom.setAttribute(propertyName, attributes[propertyName]);
  });
  Utils.addClass(this.dom, classes || 'noty_btn');
  return this;
};

exports.NotyButton = NotyButton;